export class HttpRequestError extends Error {
    status: number;
    response: string | unknown;
    constructor(message: string, status: number, response: string | unknown) {
        super(message);
        this.name = 'Http Request';
        this.status = status;
        this.response = response;
    }
}
